<template>
  <Menu ref="leftMenu" :key="dynamicKey" width="auto" :active-name="menu.active" :theme="layout.theme2" :open-names="menu.open" :accordion="true">
    <template v-for="item in menuList">
      <MenuItem v-if="!!!item.hasChildList" :key="item.id" :name="item.href" :to="item.href">
        <span :key="item.id" class="layout-text">
          <i :class="item.menuLogo" :style="[{'fontSize':'14px'}]"></i>
          {{ $t(item.name) }}
          <Badge v-if="item.hasBadge" :count="$store.state[item.hasBadge]" class-name="badge-style" />
        </span>
      </MenuItem>
      <Submenu v-if="!!item.hasChildList" :key="item.id" :name="$t(item.name)">
        <template slot="title">
          <span class="layout-text">
            <i :class="item.menuLogo" :style="[{'fontSize':'14px'}]"></i>
            {{ $t(item.name) }}
          </span>
        </template>
        <template v-for="list in item.childList">
          <MenuItem v-if="!!!list.hasChildList" :key="list.id" :name="list.href" :to="list.href">
            <span class="layout-text">{{ $t(list.name) }}</span>
          </MenuItem>
          <Submenu v-if="!!list.hasChildList" :key="list.id" :name="$t(item.name)">
            <template slot="title">
              {{ $t(list.name) }}
            </template>
            <MenuItem v-for="third in list.childList" :key="third.id" :name="third.href" :to="third.href">{{ $t(third.name) }}</MenuItem>
          </Submenu>
        </template>
      </Submenu>
    </template>
    <!-- <div v-show="showQR && $route.path=='/clue/myClue'" class="QR_code">
      <span @click="showQR=false">X</span>
      <img src="../../assets/images/ZX_QR_code.png" alt="">
    </div> -->
  </Menu>
</template>
<script>
import btnComponent from '../btnComponent/btnComponent.vue'
export default {
  components: {
    btnComponent
  },
  props: ['menuList'],
  data () {
    return {
      collapsed: false,
      showQR: true,
      dynamicKey: this.$route.path,
      menu: {
        open: [this.$route.matched[0].name], // 展开的 Submenu 的 name 集合
        active: this.$route.path// 激活菜单的 name 值
      },
      layout: {
        theme2: 'light'// 菜单主题
      },
      btnCtrl: ''
    }
  },
  computed: {
    openTagMenu() {
      return this.$store.getters.openTagMenu
    }
  },
  watch: {
    $route(to, from) {
      this.btnCtrl = this.$route.path
      this.addItem()
      this.fnMenuChange()
    }
  },
  mounted: function () {
    this.btnCtrl = this.$route.path
    this.fnMenuChange()
    // 解决页面刷新后，侧边栏菜单无法定位到当前路由的问题
    this.changeMenuKey()
  },
  methods: {
    changeMenuKey() {
      // 页面刷新后，设置与之前路由不同的key，强制侧边栏组件重新渲染
      this.dynamicKey = this.$route.path + new Date().getTime()
    },
    /* 激活菜单 */
    fnMenuChange () {
      this.menu.open = []
      this.$route.matched.forEach((item, index) => {
        if (index < this.$route.matched.length - 1) {
          this.menu.open.push(item.name)
        }
      })
      const n = this.nthIndexOf(this.$route.path, '/', 2)
      if (n > 0) {
        this.menu.active = this.$route.path.slice(0, n)
      } else {
        this.menu.active = this.$route.path
      }
      // this.menu.active = this.$route.path;
      this.$nextTick(function() {
        this.$refs.leftMenu.updateOpened()// 手动更新展开的子目录
        this.$refs.leftMenu.updateActiveName()// 手动更新当前选择项
      })
    },
    nthIndexOf(str, c, n) {
      var x = str.indexOf(c)
      for (var i = 0; i < n; i++) {
        x = str.indexOf(c, x + 1)
      }
      return x
    },
    // tag页签
    addItem() {
      const path = this.$route.fullPath
      const name = this.$route.meta.name
      const type = this.$route.meta.type
      const tagMenuPathArr = this.openTagMenu.tagMenuPathArr
      const tagMenuArr = this.openTagMenu.tagMenuArr
      if (tagMenuPathArr.indexOf(path) == -1 && type == '菜单') {
        tagMenuArr.push({ path: path, name: name })
        tagMenuPathArr.push(path)
        this.$store.commit('openTagMenu', { tagMenuArr: tagMenuArr, tagMenuPathArr: tagMenuPathArr })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.layout-text{
    i{
        margin-right: 8px;
    }
    display: inline-block;
    width:123px;
}
</style>
<style lang="scss">
    .ivu-menu {
        font-size: 12px;
    }
    .ivu-menu-item {
        font-size: 12px;
    }
    .ivu-menu-vertical .ivu-menu-item,
    .ivu-menu-vertical .ivu-menu-submenu-title {
        padding: 12px 8px 12px 15px;
    }
    .ivu-menu-vertical .ivu-menu-submenu-title-icon {
        margin-right: 0px;
    }
    .QR_code{
        position: fixed;
        left: 4px;
        bottom: 5%;
        width: 175px;
        height: 210px;
        border-radius: 10px;
        overflow: hidden;
        span{
            color: white;
            position: absolute;
            font-size: 20px;
            right: 5px;
            cursor: pointer;
        }
        img{
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/menushow/menuShow.vue